import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../conf/axiosBaseQuery";
import { I_GetFileValuesQRTK } from "./values/download-file.response";

export const DownloadQueryServices = createApi({
  reducerPath: "get-files-services-rf",
  baseQuery: axiosBaseQuery(),
  endpoints: builder => ({
    downloadFile: builder.mutation({
      query: (values: I_GetFileValuesQRTK) => ({
        url: values.url,
        method: "GET"
        // responseType: 'arraybuffer'
      }),
      transformResponse(response, meta, arg) {
        return response;
      }
    })
  })
});

export const { useDownloadFileMutation } = DownloadQueryServices;
